import {
  FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID,
  IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID,
} from 'actions/apiActionConstants'
import { reducerSwitch, createReducer } from 'lib/redux/reducerUtils'
import { API_CALL_REQUEST, API_CALL_FAILURE, API_CALL_SUCCESS } from 'actions/actionConstants'

export const initialWhiteLabelAppState: App.WhiteLabelAppState = {
  promoCode: '',
  fetching: false,
  updating: false,
  fetchError: undefined,
  updateError: undefined,
}

const apiRequests = reducerSwitch<App.WhiteLabelAppState>({
  [FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID]: () => ({
    fetching: true,
  }),
  [IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID]: () => ({
    fetching: true,
  }),
})

const apiSuccesses = reducerSwitch<App.WhiteLabelAppState>({
  [FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID]: (state, action) => ({
    fetching: false,
    promoCode: action.data.promoCode,
  }),
  [IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID]: () => ({
    updating: false,
  }),
})

const apiFailures = reducerSwitch<App.WhiteLabelAppState>({
  [FETCH_WHITE_LABEL_APP_PROMO_CODE_BY_MEMBER_ID]: (_, action) => ({
    fetching: false,
    fetchError: action.error,
  }),
  [IGNORE_WHITE_LABEL_APP_PROMO_FOR_MEMBER_ID]: (_, action) => ({
    updating: false,
    updateError: action.error,
  }),
})

export default createReducer<App.WhiteLabelAppState>(initialWhiteLabelAppState, {
  [API_CALL_REQUEST]: (state, action) => apiRequests(action.api)(state, action),
  [API_CALL_FAILURE]: (state, action) => apiFailures(action.api)(state, action),
  [API_CALL_SUCCESS]: (state, action) => apiSuccesses(action.api)(state, action),
})
